import { render } from "./CommentProducts.vue?vue&type=template&id=82c7bcd0&scoped=true"
import script from "./CommentProducts.vue?vue&type=script&lang=js"
export * from "./CommentProducts.vue?vue&type=script&lang=js"

import "./CommentProducts.vue?vue&type=style&index=0&id=82c7bcd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c7bcd0"]])

export default __exports__